import React from "react";
import moment from "moment";
import DatePicker from "Components/common/DatePicker/DatePicker";

class Field extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { field } = this.props;

        return (
            <div class="formContainer">
                <label>{ field.label }</label>
                { this.props.view === "form" && (
                    <React.Fragment>
                        { field.component? field.component:  
                            <input
                                id={field.id}
                                class={field.fieldClass}
                                type="text"
                                placeholder={field.placeholder}
                                value={field.value}
                                onChange={field.onChange}
                            />
                            }
                        {/* { !field.component && (
                            <input 
                                id={ field.id } 
                                class={ field.fieldClass }
                                type="text" 
                                placeholder={ field.placeholder } 
                                value={ field.value } 
                                onChange={ field.onChange}
                            />
                        )} */}
                    </React.Fragment>
                )}
                { this.props.view === "view" && (
                    <span class={`${ field.defaultValue ? "" : "placeholder" }`}>{ field.defaultValue ? field.defaultValue : field.placeholder }</span>
                )}
            </div>
        );
    }
}

export default Field;